import { useState, useContext, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { getStyled } from './styles';

import {
  Checkbox,
  FormControlLabel,
  Button,
  TextField,
  Link,
  Container,
  InputAdornment,
  IconButton,
  useTheme,
  Grid,
} from '@mui/material';

import {
  Add,
  Login as LoginIcon,
  Visibility,
  VisibilityOff,
  AccountCircle,
  Lock,
} from '@mui/icons-material';

import { i18n } from '../../translate/i18n';
import { AuthContext } from '../../context/Auth/AuthContext';
import useSettings from '../../hooks/useSettings';

import logo from '../../assets/logo-login.png';

const Login = () => {
  const theme = useTheme();
  const classes = getStyled(theme, logo);

  const [user, setUser] = useState({
    email: '',
    password: '',
    rememberMe: false,
  });
  const [allowSignup, setAllowSignup] = useState(false);
  const { getPublicSetting } = useSettings();
  const { handleLogin } = useContext(AuthContext);
  const [showPassword, setShowPassword] = useState(false);

  const handleChangeInput = (name, value) => {
    setUser({ ...user, [name]: value });
  };

  const handlSubmit = (e) => {
    e.preventDefault();
    handleLogin(user);
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  useEffect(() => {
    getPublicSetting('allowSignup')
      .then((data) => {
        setAllowSignup(data === 'enabled');
      })
      .catch((error) => {
        console.error('Error reading setting', error);
      });
  }, [getPublicSetting]);

  return (
    <>
      <div style={classes.root}>
        <Container component='main' maxWidth='xs'>
          <div style={classes.paper}>
            <div>
              <img style={classes.logoImg} alt='logo' />
            </div>
            <form style={classes.form} noValidate onSubmit={handlSubmit}>
              <TextField
                variant='outlined'
                margin='normal'
                required
                fullWidth
                id='email'
                label={i18n.t('login.form.email')}
                name='email'
                value={user.email}
                onChange={(e) =>
                  handleChangeInput(e.target.name, e.target.value.toLowerCase())
                }
                autoComplete='email'
                autoFocus
                sx={classes.customInput}
                slotProps={{
                  startAdornment: (
                    <InputAdornment position='start'>
                      <AccountCircle />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                variant='outlined'
                margin='normal'
                required
                fullWidth
                name='password'
                label={i18n.t('login.form.password')}
                type={showPassword ? 'text' : 'password'}
                id='password'
                value={user.password}
                onChange={(e) =>
                  handleChangeInput(e.target.name, e.target.value)
                }
                sx={classes.customInput}
                autoComplete='current-password'
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position='start'>
                        <Lock sx={{ color: '#181c35' }} />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position='end'>
                        <IconButton
                          aria-label='toggle password visibility'
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          sx={{ color: '#181c35' }}
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  },
                }}
              />
              <Grid container justify='flex-end'>
                <Grid size={6} style={{ textAlign: 'right' }}>
                  <Link
                    component={RouterLink}
                    to='/forgot-password'
                    variant='body2'
                    style={classes.customLink}
                  >
                    Esqueceu sua senha?
                  </Link>
                </Grid>
              </Grid>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={user.rememberMe}
                    onChange={(e) =>
                      handleChangeInput('rememberMe', e.target.checked)
                    }
                    sx={classes.customCheck}
                  />
                }
                label='Lembre-se de mim'
              />
              <Button
                type='submit'
                fullWidth
                variant='outlined'
                color='primary'
                style={classes.customStyle2}
                startIcon={<LoginIcon />}
              >
                {i18n.t('login.buttons.submit')}
              </Button>
              <Button
                fullWidth
                variant='outlined'
                component={RouterLink}
                to='/signup'
                startIcon={<Add />}
                style={classes.customStyle}
              >
                {i18n.t('login.buttons.register')}
              </Button>
              {allowSignup && (
                <Grid container>
                  <Grid size='auto'>
                    <Link
                      fullWidth
                      variant='outlined'
                      component={RouterLink}
                      style={classes.customStyle}
                      to='/signup'
                    >
                      {i18n.t('login.buttons.register')}
                    </Link>
                  </Grid>
                </Grid>
              )}
            </form>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Login;
